import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import LocationPage from "@/pages/LocationPage";
import ServicePage from "@/pages/ServicePage";
import ServicesPage from "@/pages/ServicesPage";
import PricesPage from "@/pages/PricesPage";
import ContactPage from "@/pages/ContactPage";
import BusinessContractsPage from "@/pages/BusinessContractsPage";
import PackagesPage from "@/pages/PackagesPage";
import LandlordsPage from "@/pages/LandlordsPage";
import { PrivacyPolicy, CookiePolicy, TermsAndConditions } from "@/pages/LegalPages";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import { SERVICE_PAGES } from "@/data/services";

const SERVICE_SLUGS = Object.keys(SERVICE_PAGES).filter((s) => s !== "business-cleaning-contracts-dublin");

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/prices" element={<PricesPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/business-cleaning-contracts-dublin" element={<BusinessContractsPage />} />
        <Route path="/moving-cleaning-packages" element={<PackagesPage />} />
        <Route path="/landlords-estate-agents" element={<LandlordsPage />} />
        {SERVICE_SLUGS.map((slug) => (
          <Route key={slug} path={`/${slug}`} element={<ServicePage slug={slug} />} />
        ))}
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/:slug" element={<LocationPage />} />
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
